import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import ResetFormAlert from "./ResetFormAlert";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import Validation from "../../../../utils/Validation";
import { allFormElementFields, formElementFields } from "./refferAllFields";
import FormField from "../../../../components/common/FormField";
import { useDispatch } from "react-redux";
import {
  addReferrerAction,
  setAddReferrerResponse,
  updateReferrerAction,
  updateReferrerResponse,
} from "../../../../store/reducers/referrerSlice";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";

interface UserDetail {
  [key: string]: any; // Allow dynamic string keys
  name: any | null;
  emailContact: any | null;
  phone: any | null;
  contactName: any | null;
  notes: any | null;
}

interface ManageRefferProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectUser: any; // Adjust type as per your requirement
  isSmallScreen?: boolean; //
}

const ManageReffer = (props: ManageRefferProps) => {
  const classes = useStyles();
  const { selectUser, onHide, open, title, isSmallScreen } = props;
  const initialUserDetail = {
    name: "",
    emailContact: "",
    phone: "",
    contactName: "",
    notes: "",
  };

  const [userDetail, setUserDetail] = useState<UserDetail>(initialUserDetail);
  const [fieldsToRender, setFieldsToRender] = useState(formElementFields); // Default to basic fields

  useEffect(() => {
    // Dynamically update form fields based on screen size
    if (isSmallScreen) {
      setFieldsToRender(formElementFields);
    } else {
      setFieldsToRender(allFormElementFields);
    }
  }, [isSmallScreen]);

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    name: userDetail?.name,
    emailContact: userDetail?.emailContact,
    phone: userDetail?.phone,
  });

  const dispatch = useDispatch();

  const [isActionCalled, setIsActionCalled] = useState(false);

  useEffect(() => {
    if (selectUser) {
      setUserDetail({
        ...userDetail,
        name: selectUser?.name,
        emailContact: selectUser.email ?? "",
        phone: selectUser.phone ?? "",
        contactName: selectUser?.contact_name,
        notes: selectUser?.notes,
      });
    }
  }, [selectUser]);

  const hideHandler = () => {
    onHide();
    handleClear();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    dispatch(setAddReferrerResponse(false));
    dispatch(updateReferrerResponse(false));
    setUserDetail(initialUserDetail);
  };

  const handleClear = () => {
    if (selectUser?.id) {
      setUserDetail(selectUser);
    } else {
      setUserDetail(initialUserDetail);
    }
    resetAllValidator(); // Reset all validation errors
    setIsClickReset(false);
    setAlertModelShow(false);
    // setIsEmailActionCalled(false);
    // setRoleModules([]);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      console.log("userDetail", userDetail);
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        if (selectUser?.id) {
          dispatch(updateReferrerAction({ ...userDetail, id: selectUser?.id }));
        } else {
          dispatch(addReferrerAction(userDetail));
        }
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const handleInputChange = (field: string, value: any) => {
    console.log("field-value", field, value);
    setUserDetail((prevState) => ({
      ...prevState,
      [field]: value,
    }));

    // dispatch(
    //   setNewSubUserLocal({
    //     ...newUserLocal,
    //     [field]: value,
    //   })
    // );

    resetValidator(field);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };
  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"md"}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px !important" }}>
          <DialogContentText>
            <>
              <Notification />
              <Grid
                container
                spacing={2}
                sx={{
                  background: "#E5F4F1",
                  paddingRight: "16px",
                  paddingBottom: "10px",
                  borderRadius: "5px",
                  border: "1px solid #CFCFCF",
                  marginTop: "10px",
                }}
              >
                {fieldsToRender.map((field, i) => {
                  return (
                    <FormField
                      key={i}
                      onPaste={(e) =>
                        field?.id === "notes" ? "" : e.preventDefault()
                      }
                      onKeyDown={(event: any) => {
                        console.log(
                          "event log-",
                          event,
                          event.target.value + event.key
                        );
                        if (
                          event.keyCode === 8 ||
                          event.keyCode === 9 ||
                          event.keyCode === 37 ||
                          event.keyCode === 38 ||
                          event.keyCode === 39 ||
                          event.keyCode === 40 ||
                          event.keyCode === 18 ||
                          event.keyCode === 17 ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      {...{
                        ...field,
                        ...{
                          variant: "outlined", // Adding this variant prop
                          inSingleGridForm: true,
                          isNonMarginTop: true,
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx: {
                              height:
                                field?.id === "notes" &&
                                userDetail[field?.id]?.length > 36
                                  ? "auto"
                                  : "36px",
                              padding: field?.id === "notes" ? "4px" : "",
                            },
                            // ...(selectUser && { disabled: field?.editReadOnly }),
                            autocomplete: "user-new-field",
                          },
                          multiline: field?.id === "notes" && true,
                          marginLeftCountryCode: "-14px",
                          value: userDetail ? userDetail[field.id] : "",
                          onBlur: onBlurAction,
                          // selectedValues: userDetail[field?.id],
                          onChange: (e: any) =>
                            handleInputChange(field.id, e.target.value), // Call onChange prop
                          error: error && error[field?.id],
                        },
                      }}
                    />
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageReffer;
